import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {UILayout} from '@gongxigames/framework/slotV2/types';

export const uiLayoutsStore = Store.createStore({
    /**
     * Contains the current UI layout configuration.
     */
    ui_layout: Store.signal(null as UILayout | null ),
});